import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewAdminService {

  constructor(private http: HttpClient) { }

  addAdmin(formData:any): Observable<any>{
    // console.log("arrived in service", formData);
    return this.http.post(`${environment.apiUrl}/api/register`, formData)
  }
}
